import React from 'react';
import PropTypes from 'prop-types';

import { ConfigProvider } from '@decisiv/ui-components';
import PasswordField from '@decisiv/ui-components/lib/components/PasswordField';

// KDS PasswordField does not accept a `label` prop and hardcodes its label and
// the Show/Hide toggle text to the ConfigProvider's `passwordField`
// translations (which default to English). This wrapper feeds those three
// strings in through a scoped ConfigProvider so each field can be localized
// from Rails I18n and given its own label. Undefined values are dropped by the
// ConfigProvider merge, falling back to the KDS English defaults.
function LocalizedPasswordField({
  label,
  showPasswordLabel,
  hidePasswordLabel,
  ...rest
}) {
  return (
    <ConfigProvider
      translations={{
        passwordField: {
          password: label,
          showPassword: showPasswordLabel,
          hidePassword: hidePasswordLabel,
        },
      }}
    >
      <PasswordField {...rest} />
    </ConfigProvider>
  );
}

LocalizedPasswordField.propTypes = {
  label: PropTypes.string,
  showPasswordLabel: PropTypes.string,
  hidePasswordLabel: PropTypes.string,
};

LocalizedPasswordField.defaultProps = {
  label: undefined,
  showPasswordLabel: undefined,
  hidePasswordLabel: undefined,
};

export default LocalizedPasswordField;
